// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBzCT0TZ_L9cd_Qnj2ZQjSskurFYMv_BJ0",
  authDomain: "almtv-bb6f7.firebaseapp.com",
  projectId: "almtv-bb6f7",
  storageBucket: "almtv-bb6f7.firebasestorage.app",
  messagingSenderId: "353083476394",
  appId: "1:353083476394:web:9b63958302270420ff03d3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore (database)
const db = getFirestore(app);

// Initialize Firebase Authentication
const auth = getAuth(app);

export { auth };   // named export for auth
export default db; // default export for db
